import { Suspense } from 'react'
import { PipelineSwitcherFallback } from '@/components/layout/breadcrumbs/app/pipeline-switcher/fallback'
import { PipelineSwitcherData } from '@/components/layout/breadcrumbs/app/pipeline-switcher/switcher'

export const PipelineSwitcher = () => (
  <Suspense fallback={<PipelineSwitcherFallback />}>
    <PipelineSwitcherData />
  </Suspense>
)
